import BaseDialog, { customStyles } from 'components/dialog'
import ButtonBase from 'components/partials/button'
import { IAgencyActivity } from 'queries/admin/agencyActivity'
import React from 'react'
import { IRetryDetail } from 'pages/agency-group-management/interface'
import DetailAgencyActivityTable from './detail-table'

interface Props {
  agencyActivity: IAgencyActivity
  isOpenDialog: boolean
  handleCloseDialog: () => void
  dialogStyle: ReactModal.Styles['content']
}

const DetailAgencyActivityLog: React.FC<Props> = ({
  agencyActivity,
  isOpenDialog,
  handleCloseDialog,
  dialogStyle,
}) => {
  let retryDetails: IRetryDetail[] = []
  if (agencyActivity.retry_details) {
    const temp = agencyActivity.retry_details.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
    retryDetails = temp as IRetryDetail[]
  }
  const style = { content: { ...customStyles.content, ...dialogStyle } }

  return (
    <BaseDialog modalIsOpen={isOpenDialog} customStyles={style}>
      <div className="space-y-2">
        <div className="flex justify-center pb-5">
          <span>Agency Activity Log Detail</span>
        </div>

        <DetailAgencyActivityTable
          handleFetchMore={() => {}}
          handleRefetch={() => {}}
          hasMoreData={false}
          isLoading={false}
          retryDetails={retryDetails}
        />

        <div className="flex pt-5 justify-end">
          <ButtonBase onClick={handleCloseDialog}>Close</ButtonBase>
        </div>
      </div>
    </BaseDialog>
  )
}

export default DetailAgencyActivityLog
